import React, { useMemo } from "react";
import { useApp } from "@/context/AppContext";
import { useAuth } from "@/context/AuthContext";
import { InstallBanner } from "@/components/InstallApp";
import {
  HeroSection, StatsSection, TipQuoteSection, TrialBanner, UpsellSection, RecentCravings, greetingFor, trialDaysLeft,
} from "@/components/home/HomeSections";

export default function Home() {
  const { state, stats } = useApp();
  const { plan, user } = useAuth();
  const greeting = useMemo(() => greetingFor(new Date().getHours()), []);
  const daysLeft = trialDaysLeft(user);

  return (
    <div className="space-y-10">
      <HeroSection greeting={greeting} name={state.profile.name} stats={stats} />
      <StatsSection stats={stats} />
      <TipQuoteSection />
      <InstallBanner />
      {daysLeft !== null && <TrialBanner daysLeft={daysLeft} />}
      {plan === "free" && <UpsellSection />}
      <RecentCravings items={stats.sorted} />
    </div>
  );
}
